import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '6a33302fadcd30b63bfbce59';
declare global {
  interface Window {
    pixelId?: string;
  }
}
export function UtmifyPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const loadPixel = () => {
      if (document.querySelector('script[src="https://cdn.utmify.com.br/scripts/pixel/pixel.js"]')) {
        return;
      }
      window.pixelId = PIXEL_ID;
      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
      document.head.appendChild(script);
    };
    const loadUtms = () => {
      if (document.querySelector('script[src="https://cdn.utmify.com.br/scripts/utms/latest.js"]')) {
        return;
      }
      const utmsScript = document.createElement('script');
      utmsScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
      utmsScript.setAttribute('data-utmify-prevent-xcod-sck', '');
      utmsScript.setAttribute('data-utmify-prevent-subids', '');
      utmsScript.async = true;
      utmsScript.defer = true;
      document.head.appendChild(utmsScript);
    };
    const loadAll = () => {
      loadPixel();
      loadUtms();
    };
    const idle: any = (window as any).requestIdleCallback;
    if (typeof idle === 'function') {
      idle(loadAll, {
        timeout: 3000
      });
    } else {
      setTimeout(loadAll, 1500);
    }
  }, []);
  return null;
}